var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"aspect-ratio",staticStyle:{"--aspect-ratio":"16/9"},attrs:{"disableremoteplayback":"","disablepictureinpicture":"","muted":"","playsinline":"","preload":"auto","x-webkit-airplay":"deny"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }